// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"NewHero_heroContainer__3dwnE","heroInnerContainer":"NewHero_heroInnerContainer__2e121"};